import { getUnixTime, subDays } from 'date-fns'

export default getUnixTime(subDays(Date.now(), 2))
